import { alpha, darken, lighten } from "@mui/material";
function getDataTableBorderColor(theme) {
    if ('light' === theme.palette.mode) return lighten(alpha(theme.palette.divider, 1), 0.88);
    return darken(alpha(theme.palette.divider, 1), 0.68);
}
const DATA_TABLE_COMPACT_DENSITY_FACTOR = 0.7;
export { DATA_TABLE_COMPACT_DENSITY_FACTOR, getDataTableBorderColor };

//# sourceMappingURL=model.js.map